import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import CssBaseline from "@mui/material/CssBaseline";

import IconDown from "../../assets/icons/down.webp";
import IconMenu from "../../assets/icons/menu.webp";
import Logo from "../../assets/logo.webp";

import "./NavBarCustom.css";

function NavBarCustom({ actualRef }) {
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();
	const portfolioTypes = t("portfolio.projectTypeLabels", {
		returnObjects: true,
	});

	const [actualPortfolioElement, setActualPortfolioElement] = useState(
		window.location.href
	);
	const [actualElement, setActualElement] = useState();

	const [openBurgerMenu, setOpenBurgerMenu] = useState(
		"custom-navbar-mobile-menu-closed"
	);
	const [openDropdownPortfolio, setOpenDropdownPortfolio] = useState(
		"custom-navbar-dropdown-portfolio-closed"
	);
	const [actualLanguage, setActualLanguage] = useState(
		i18n.language.includes("es") ? t("navbar.spanish") : t("navbar.english")
	);
	const [openDropdownLanguage, setOpenDropdownLanguage] = useState(
		"custom-navbar-dropdown-content-language-closed"
	);
	/* const [actualCurrency, setActualCurrency] = useState(
		localStorage.getItem("actual-currency")
	);
	const [openDropdownCurrency, setOpenDropdownCurrency] = useState(
		"custom-navbar-dropdown-content-currency-closed"
	); */

	const handleBurgerMenu = (e) => {
		e.preventDefault();
		if (openBurgerMenu.includes("closed")) {
			setOpenBurgerMenu("custom-navbar-mobile-menu-opened");
		} else {
			setOpenBurgerMenu("custom-navbar-mobile-menu-closed");
		}
	};

	const handleChangePortfolio = (e, type) => {
		e.preventDefault();
		navigate("/portafolio/" + type.toLowerCase());
		setOpenDropdownPortfolio("custom-navbar-dropdown-portfolio-closed");
	};

	const handleDropdownPortfolio = (e) => {
		e.preventDefault();
		if (openDropdownPortfolio.includes("closed")) {
			setOpenDropdownPortfolio("custom-navbar-dropdown-portfolio-opened");
		} else {
			setOpenDropdownPortfolio("custom-navbar-dropdown-portfolio-closed");
		}
	};

	/* const handleChangeCurrency = (e, currency) => {
		e.preventDefault();
		localStorage.setItem("actual-currency", currency);
		setActualCurrency(currency);
		handleDropdownCurrency(e);
	};

	const handleDropdownCurrency = (e) => {
		e.preventDefault();
		if (openDropdownCurrency.includes("closed")) {
			setOpenDropdownCurrency("custom-navbar-dropdown-content-currency-opened");
		} else {
			setOpenDropdownCurrency("custom-navbar-dropdown-content-currency-closed");
		}
	};

	useEffect(() => {
		const actualCurrency = localStorage.getItem("actual-currency");
		if (actualCurrency) {
			setActualCurrency(actualCurrency);
		} else {
			localStorage.setItem("actual-currency", "EUR");
			setActualCurrency("EUR");
		}
	}, []); */

	const handleChangeLanguage = (e, language) => {
		e.preventDefault();
		setActualLanguage(language);
		handleTranslation(e, language);
		handleDropdownLanguage(e);
		if (language === "ESP") {
			setActualLanguage(t("navbar.spanish"));
		} else if (language === "ENG") {
			setActualLanguage(t("navbar.english"));
		}
		window.location.reload();
	};

	const handleDropdownLanguage = (e) => {
		e.preventDefault();
		if (openDropdownLanguage.includes("closed")) {
			setOpenDropdownLanguage("custom-navbar-dropdown-content-language-opened");
		} else {
			setOpenDropdownLanguage("custom-navbar-dropdown-content-language-closed");
		}
	};

	const handleNavigation = (e, page) => {
		e.preventDefault();
		navigate("/" + page);
	};

	const handleTranslation = (e, language) => {
		e.preventDefault();
		if (language === "ENG") {
			i18n.changeLanguage("en-US");
		} else if (language === "ESP") {
			i18n.changeLanguage("es-ES");
		}
	};

	useEffect(() => {
		setActualElement(actualRef);
		if (window.location.href.includes("portfolio")) {
			setActualPortfolioElement(window.location.href);
		} else {
			setActualPortfolioElement("");
		}
	}, [actualRef, window.location.href]);

	return (
		<React.Fragment>
			<CssBaseline />
			<div className="custom-navbar">
				<div className="custom-navbar-top">
					<div
						className="custom-navbar-container"
						style={{ justifyContent: "right", gap: "8px" }}
					>
						{/* <div className="custom-navbar-dropdown">
							<button
								className="custom-navbar-button custom-navbar-text"
								onClick={(e) => handleDropdownCurrency(e)}
							>
								{actualCurrency}
								<img alt="down" src={IconDown} className="custom-navbar-icon" />
							</button>

							<div className={openDropdownCurrency}>
								<div
									className="custom-navbar-dropdown-content-item"
									onClick={(e) => handleChangeCurrency(e, "EUR")}
								>
									{t("navbar.eur")}
								</div>
								<div
									className="custom-navbar-dropdown-content-item"
									onClick={(e) => handleChangeCurrency(e, "USD")}
								>
									{t("navbar.usd")}
								</div>
							</div> 
						</div>
						*/}
						<div className="custom-navbar-dropdown">
							<button
								className="custom-navbar-button custom-navbar-text"
								onClick={(e) => handleDropdownLanguage(e)}
							>
								{actualLanguage}
								<img alt="down" src={IconDown} className="custom-navbar-icon" />
							</button>

							<div className={openDropdownLanguage}>
								<div
									className="custom-navbar-dropdown-content-item"
									onClick={(e) => handleChangeLanguage(e, "ENG")}
								>
									<h6>{t("navbar.english")}</h6>
								</div>
								<div
									className="custom-navbar-dropdown-content-item"
									onClick={(e) => handleChangeLanguage(e, "ESP")}
								>
									<h6>{t("navbar.spanish")}</h6>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="custom-navbar-bottom">
					<div className="custom-navbar-container">
						<div
							className="custom-navbar-container-icon"
							onClick={(e) => handleNavigation(e, "")}
						>
							<img
								alt={"logo"}
								src={Logo}
								className="custom-navbar-container-icon-image"
							/>
						</div>
						<div className="custom-navbar-container-center">
							<div
								id="custom-navbar-services"
								className={`${
									actualElement && actualElement.includes("services")
										? "custom-navbar-item-activated"
										: "custom-navbar-item-disabled"
								}`}
								onClick={(e) => handleNavigation(e, "servicios")}
							>
								<h5 className="h5-bold">{t("navbar.services")}</h5>
							</div>
							<div
								id="custom-navbar-portfolio"
								className={`${
									actualElement && actualElement.includes("portfolio")
										? "custom-navbar-item-activated"
										: "custom-navbar-item-disabled"
								}`}
							>
								<div onClick={(e) => handleDropdownPortfolio(e)}>
									<h5 className="h5-bold">{t("navbar.portfolio")}</h5>
								</div>
								<div
									className={`${openDropdownPortfolio} custom-navbar-dropdown-portfolio`}
								>
									{Object.keys(portfolioTypes).map(function (item, index) {
										return (
											<h5
												key={index}
												className={`custom-navbar-dropdown-portfolio-item ${
													actualPortfolioElement.split("/")[4] &&
													actualPortfolioElement.split("/")[4].toUpperCase() ===
														item
														? "custom-navbar-dropdown-portfolio-item-activated"
														: "custom-navbar-dropdown-portfolio-item-disabled"
												}`}
												onClick={(e) => handleChangePortfolio(e, item)}
											>
												{portfolioTypes[item]}
											</h5>
										);
									})}
								</div>
							</div>
							<div
								id="custom-navbar-team"
								className={`${
									actualElement && actualElement.includes("team")
										? "custom-navbar-item-activated"
										: "custom-navbar-item-disabled"
								}`}
								onClick={(e) => handleNavigation(e, "equipo")}
							>
								<h5 className="h5-bold">{t("navbar.team")}</h5>
							</div>
							<div
								id="custom-navbar-contact"
								className={`${
									actualElement && actualElement.includes("contact")
										? "custom-navbar-item-activated"
										: "custom-navbar-item-disabled"
								}`}
								onClick={(e) => handleNavigation(e, "contacto")}
							>
								<h5 className="h5-bold">{t("navbar.contact")}</h5>
							</div>
						</div>
					</div>
				</div>
				<div className="custom-navbar-mobile">
					<div
						className="custom-navbar-container-icon"
						onClick={(e) => handleNavigation(e, "")}
					>
						<img
							alt={"logo"}
							src={Logo}
							className="custom-navbar-container-icon-image"
						/>
					</div>
					<div className="custom-navbar-dropdown">
						<div
							className="custom-navbar-mobile-icon-container"
							onClick={(e) => handleBurgerMenu(e)}
						>
							<img
								alt="menu"
								src={IconMenu}
								className="custom-navbar-mobile-icon"
							/>
						</div>

						<div className={openBurgerMenu}>
							<div className="custom-navbar-mobile-menu">
								<div
									className={`custom-navbar-mobile-menu-item ${
										actualElement && actualElement.includes("services")
											? "custom-navbar-mobile-menu-item-activated"
											: "custom-navbar-mobile-menu-item-disabled"
									}`}
									onClick={(e) => handleNavigation(e, "servicios")}
								>
									{t("navbar.services")}
								</div>
								{Object.keys(portfolioTypes).map(function (item, index) {
									return (
										<div
											key={index}
											className={`custom-navbar-mobile-menu-item ${
												actualPortfolioElement.split("/")[4] &&
												actualPortfolioElement.split("/")[4].toUpperCase() ===
													item
													? "custom-navbar-mobile-menu-item-activated"
													: "custom-navbar-mobile-menu-item-disabled"
											}`}
											onClick={(e) => handleChangePortfolio(e, item)}
										>
											{t("navbar.portfolio")} {portfolioTypes[item]}
										</div>
									);
								})}
								<div
									className={`custom-navbar-mobile-menu-item ${
										actualElement && actualElement.includes("team")
											? "custom-navbar-mobile-menu-item-activated"
											: "custom-navbar-mobile-menu-item-disabled"
									}`}
									onClick={(e) => handleNavigation(e, "equipo")}
								>
									{t("navbar.team")}
								</div>
								<div
									className={`custom-navbar-mobile-menu-item ${
										actualElement && actualElement.includes("contact")
											? "custom-navbar-mobile-menu-item-activated"
											: "custom-navbar-mobile-menu-item-disabled"
									}`}
									onClick={(e) => handleNavigation(e, "contacto")}
								>
									{t("navbar.contact")}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
}
export default NavBarCustom;
